var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cube-page',{attrs:{"title":"部门销售"}},[_c('div',{staticStyle:{"background-color":"white","margin-top":"15px"},attrs:{"slot":"content"},slot:"content"},[_c('wmq-layout',{ref:"detail",attrs:{"rootLayoutConfig":_vm.rootLayoutConfig}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }